import React from 'react'
import { connect } from 'react-redux'
import { defineMessages, FormattedHTMLMessage } from 'react-intl'

import { checkIsFlayBet, isRingo } from '../../shared/domainUtils'

const messages = defineMessages({
  copyright: {
    id: 'footer.fairplay.copyright',
    defaultMessage: '&copy; {year} Букмекерская компания «Fair Play»',
  },
  copyright_kz: {
    id: 'footer.fairplay.copyright_kz',
    defaultMessage: '&copy; {year} ТОО «BETtery». Торговая марка «Fair Play» Лицензия № 320 от 23.08.2019',
  },
  copyright_ringobet: {
    id: 'footer.fairplay.copyright_ringobet',
    defaultMessage: '&copy; {year} ТОО «TakeBet». Торговая марка «RingoBet» Лицензия № 34 от 12.07.2022',
  },
})

function SocialLink({ social, href }) {
  return (
    <li>
      <a href={href} className={`footer-social-buttons--${social}`} target="_blank" />
    </li>
  )
}

function RechargeProvider({ provider, href }) {
  return (
    <li className={`recharge-providers__provider recharge-providers__provider--${provider}`}>
      <a href={href ? href : '#'} target={href ? '_blank' : ''} />
    </li>
  )
}

function Footer({ countryCode }) {
  const copyrightMessage =
    countryCode === 'KZ' ? (isRingo ? messages.copyright_ringobet : messages.copyright_kz) : messages.copyright

  return (
    <footer className="page-footer">
      {countryCode === 'KZ' &&
        (isRingo ? (
          <div className="recharge-providers cf">
            <ul>
              <RechargeProvider provider="visa" />
              <RechargeProvider provider="qiwi" />
              <RechargeProvider provider="wooppay" />
              <RechargeProvider provider="kassa24" />
            </ul>
          </div>
        ) : (
          <div className="recharge-providers cf">
            <ul>
              <RechargeProvider provider="visa" />
              <RechargeProvider provider="qiwi" />
              <RechargeProvider provider="wooppay" />
              <RechargeProvider provider="kassa24" />
              <RechargeProvider provider="cyberplat" />
              <RechargeProvider provider="tenge" />
              <RechargeProvider provider="quickpay" />
            </ul>
          </div>
        ))}
      {countryCode === 'KG' && (
        <div className="recharge-providers cf">
          <ul>
            <RechargeProvider provider="visa" />
            <RechargeProvider provider="bitcoin" />
            <RechargeProvider provider="ethereum" />
            <RechargeProvider provider="tether" />
            <RechargeProvider provider="opex" />
            <RechargeProvider provider="binance" />
            <RechargeProvider provider="litecoin" />
            <RechargeProvider provider="dash-dash" />
            <RechargeProvider provider="tron-trx" />
            <RechargeProvider provider="usd-coin-usdc" />
          </ul>
        </div>
      )}

      <div className="info pull-left">
        <span className={countryCode === 'KZ' ? 'plus18' : 'plus18KG'}>{'\u00A0'}</span>
        {checkIsFlayBet() ? (
          <div style={{ fontSize: 14 }}>
            <p>SmartPlay Interactive N.V., Curacao, Willemstad, Zuikertuintjeweg Z/N Zuikertuin Tower</p>
            <br />
            <p>Registration number: 161764</p>
            <br />
            <a style={{ color: '#306d41', cursor: 'pointer' }}>
              <span
                onClick={() => {
                  window.open(
                    `//help.${window.location.host}/responsible`,
                    'Menu',
                    'toolbar=no, location=no, status=no,menubar=no,scrollbars=yes, resizable=yes, width=1366, height=650'
                  )
                }}
              >
                Responsible Gaming
              </span>
            </a>
            <br />
            <a style={{ color: '#306d41', cursor: 'pointer' }}>
              <span
                onClick={() => {
                  window.open(
                    `//help.${window.location.host}`,
                    'Menu',
                    'toolbar=no, location=no, status=no,menubar=no,scrollbars=yes, resizable=yes, width=1366, height=650'
                  )
                }}
              >
                Terms and Conditions
              </span>
            </a>
            <br />
            <a style={{ color: '#306d41', cursor: 'pointer' }}>
              <span
                onClick={() => {
                  window.open(
                    `//help.${window.location.host}/privacy`,
                    'Menu',
                    'toolbar=no, location=no, status=no,menubar=no,scrollbars=yes, resizable=yes, width=1366, height=650'
                  )
                }}
              >
                KYC Policy
              </span>
            </a>
            <br />
            <a href="mailto:support@fp.bet">support@fp.bet</a>
          </div>
        ) : (
          <span className="copyright">
            <FormattedHTMLMessage {...copyrightMessage} values={{ year: new Date().getFullYear() }} />
          </span>
        )}
        {countryCode === 'KG' ? <span className="rapid">{'\u00A0'}</span> : <span className="comodo">{'\u00A0'}</span>}
      </div>
      {countryCode === 'KZ' ? (
        isRingo ? (
          <div className="footer-social-buttons">
            <ul>
              <SocialLink href="https://www.instagram.com/ringobet.kz/" social="instagram" />
              <SocialLink href="https://www.tiktok.com/@ringobet.kz/" social="tiktok" />
              <SocialLink href="https://t.me/ringobet_kaz" social="telegram" />
            </ul>
          </div>
        ) : (
          <div className="footer-social-buttons">
            <ul>
              <SocialLink href="https://www.facebook.com/fairplaykz" social="facebook" />
              <SocialLink href="https://twitter.com/fairplaykz" social="twitter" />
              <SocialLink href="https://instagram.com/fairplaykz" social="instagram" />
              <SocialLink href="https://vk.com/fairplaykz" social="vk" />
            </ul>
          </div>
        )
      ) : null}
      {countryCode === 'UZ' && (
        <div className="footer-social-buttons">
          <ul>
            <SocialLink href="https://www.instagram.com/fairplay.uz" social="instagram" />
            <SocialLink href="https://t.me/tikish_sport" social="telegram" />
          </ul>
        </div>
      )}
    </footer>
  )
}

export default connect((state) => ({
  countryCode: state.application.get('countryCode'),
}))(Footer)



// WEBPACK FOOTER //
// ./js/sport-betting/components/Footer.jsx